import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

//users
import Login from '../components/login'
import ForgotPassword from '../components/Users/forgotpassword.vue'
import NewUser from '../components/Users/newUser.vue'
import Users from '../components/partials/users.vue'
import updateUser from '../components/Users/updateUser.vue'
import Passwordtokenverification from '../components/Users/passwordTokenVerification.vue'
//transactions_credicard_log
import Content from '../components/partials/content.vue'
import Approbed from '../components/Transactions/Approved.vue'
import Pendings from '../components/Transactions/Pendings.vue'
import Rejected from '../components/Transactions//rejected.vue'
import withOut_request from '../components/Transactions//Without_request.vue'
import ApproveMesaje from '../components/Transactions/approveMessage.vue'
import TransactionDetails from '../components/partials/TransactionDetails.vue'
import rejectExplaining from '../components/Transactions/rejectExplaining.vue'
//transactions credid_card
import TlogIndex from '../components/TransactionLogs/index.vue'
import TransactionLogDetails from '../components/TransactionLogs/details.vue'
import Approbed_logs from '../components/TransactionLogs/Approved.vue'
import Pendings_logs from '../components/TransactionLogs/Pendings.vue'
import Rejected_logs from '../components/TransactionLogs/rejected.vue'
import withOut_request_logs from '../components/TransactionLogs/Without_request.vue'
//uptimeRobot
import UptimeHome from '../components/UptimeRobot/index.vue'
//notfound
import NotFound404 from '../components/404.vue'

var verify = (to, from, next) => {

  let user = store.getters.user;
  (user != null) ? next() : next({ path: '/' })

}
var logger = (to, from, next) => {

  let user = store.getters.user;
  (user == null) ? next() : next({ path: '/Home' })

}

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
    beforeEnter: logger
  },
  {
    path: '/users/create',
    name: 'newUser',
    component: NewUser,
    beforeEnter: verify
  },
  {
    path: '/users/:id/edit',
    name: 'updateUser',
    component: updateUser,
    beforeEnter: verify
  },
  {
    path: '/monits',
    name: 'uptimeRobot',
    component: UptimeHome,
  },
  {
    path: '/users',
    name: 'usersAll',
    component: Users,
    beforeEnter: verify
  },
  {
    path: '/explaining/:merchanId/:transactionId/:token',
    name: 'rejectExplaining',
    component: rejectExplaining
  },
  {
    path: '/tokenverification/:token',
    name: 'passwordtokenverification',
    component: Passwordtokenverification
  },
  {
    path: '/approved/:merchanId/:transactionId/:token',
    name: 'approved',
    component: ApproveMesaje
  },
  {
    path: '/home',
    name: 'Home',
    component: Content,
    beforeEnter: verify
  },
  {
    path: '/transactions/pendings',
    name: 'Pending',
    component: Pendings,
    beforeEnter: verify
  },
  {
    path: '/transactions/approveds',
    name: 'Approved',
    component: Approbed,
    beforeEnter: verify
  },
  {
    path: '/transactions/rejected',
    name: 'rejected',
    component: Rejected,
    beforeEnter: verify
  },
  {
    path: '/transactions/no-request',
    name: 'Without-request',
    component: withOut_request,
    beforeEnter: verify
  },
  {
    path: '/transactions/:id',
    name: 'TransactionDetails',
    component: TransactionDetails,
    beforeEnter: verify
  },
  {
    path: '/forgotPassword',
    name: 'forgot-password',
    component: ForgotPassword,
    beforeEnter: logger
  },
  {
    path: '/transactionslog',
    name: 'transactionlog_index',
    component: TlogIndex,
    beforeEnter: verify
  },
  {
    path: '/transactionslog/:id',
    name: 'TransactionLogDetails',
    component: TransactionLogDetails,
    beforeEnter: verify
  },
  {
    path: '/transactionslog/pendings',
    name: 'Pending-log',
    component: Pendings_logs,
    beforeEnter: verify
  },
  {
    path: '/transactionslog/approveds',
    name: 'Approved-log',
    component: Approbed_logs,
    beforeEnter: verify
  },
  {
    path: '/transactionslog/rejected',
    name: 'rejected-log',
    component: Rejected_logs,
    beforeEnter: verify
  },
  {
    path: '/transactionslog/no-request',
    name: 'Without-request-log',
    component: withOut_request_logs,
    beforeEnter: verify
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound404
  }
];

export default new Router({
  mode: 'history',
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js